<style lang="scss" scoped>
.employees-overtime {
  .save-info {
    background: #b4daf3;
    font-weight: 600;
    padding: 7px 70px;
    color: #0d2e48;
    margin-right: 20px;
    border: 2px solid #b4daf3;
  }

  label {
    font-weight: 600;
  }

  .input-group {
    margin-bottom: 0px !important;
  }

  .row {
    margin-bottom: 20px;
  }

  .cancel-employee {
    padding: 7px 45px;
    font-weight: 600;
    background: #f6f6f6;
    border: 2px solid #0d2e48;
    color: #0d2e48;
  }

  span.require {
    color: #ff1a1a;
  }

  span.required {
    color: #ff1a1a;
    margin-top: -15px;
  }

  .employees-form-ot {
    text-align: center;
  }

  p.note {
    font-weight: 700;
    color: #ff1a1a;
  }
}
@media screen and (max-width: 1024px) {
  .employees-overtime {
    .save-info {
      margin-right: 0 !important;
      padding: 7px !important;
      display: block;
      width: 100%;
    }
    .col-mobile {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
    .cancel-employee {
      padding: 7px 30px;
      font-weight: 600;
      background: #f6f6f6;
      border: 2px solid #0d2e48;
      color: #0d2e48;
      margin-top: 5px;
      width: 100%;
    }
    p.note {
      margin-bottom: 5px;
    }
  }
  .employees-form-ot {
    margin-top: 20px;
  }
}
</style>

<template>
  <CContainer class="employees-overtime">
    <ValidationObserver ref="formEmployee" v-slot="{ handleSubmit }">
      <CRow>
        <CCol :md="{ size: '8', offset: '2' }" class="col-mobile">
          <CCard>
            <CCardHeader>
              <label>{{ $t("commons.label_header_create_ot") }}</label>
              <br /><br />
              <label>{{ $t("commons.note") }}</label>
              <p class="note">{{ $t("commons.note_time_ot_lunch") }}</p>
              <p class="note">{{ $t("commons.note_time_ot_night") }}</p>
            </CCardHeader>
            <CCardBody>
              <CForm
                class="create_form"
                @submit.prevent="handleSubmit(createOverTimeRequest)"
              >
                <CRow v-if="projectsEmployees">
                  <CCol md="12" class="form-field">
                    <label>
                      {{ $t("commons.label_project_name") }}
                      <span class="require">*</span>
                    </label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="overtime.project_name"
                    >
                      <select
                        class="form-control"
                        v-model="forms.project_id"
                        @change="changeProject()"
                      >
                        <option
                          v-for="(option, index) in projectsEmployees"
                          :key="index"
                          :value="option.id"
                        >
                          {{ option.name }}
                        </option>
                      </select>
                      <span class="required">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md="12" class="form-field">
                    <label>
                      {{ $t("commons.label_approve_person1") }}
                      <span class="require">*</span>
                    </label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="overtime.approve"
                    >
                      <select
                        class="form-control"
                        v-model="forms.approve_person_1"
                        v-if="
                          forms.project_id &&
                          approvalPersons[forms.project_id]['level1']
                        "
                      >
                        <option
                          v-for="(option, index) in approvalPersons[
                            forms.project_id
                          ]['level1']"
                          :key="index"
                          :value="option.id"
                        >
                          {{ option.name }}
                        </option>
                      </select>
                      <select
                        class="form-control"
                        v-model="forms.approve_person_1"
                        v-else
                      >
                        <option
                          v-for="(option, index) in approvalPersons['level1']"
                          :key="index"
                          :value="option.id"
                        >
                          {{ option.name }}
                        </option>
                      </select>
                      <span class="required">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </CCol>
                </CRow>

                <CRow
                  v-if="
                    forms.approve_person_2 !== forms.approve_person_1 &&
                    ((forms.project_id &&
                      approvalPersons[forms.project_id]['level2']) ||
                      (!forms.project_id &&
                        approvalPersons['level2'] &&
                        approvalPersons['level2'].length > 0))
                  "
                >
                  <CCol md="12" class="form-field">
                    <label>
                      {{ $t("commons.label_approve_person2") }}
                      <span class="require">*</span>
                    </label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="overtime.approve2"
                    >
                      <select
                        class="form-control"
                        v-model="forms.approve_person_2"
                        v-if="
                          forms.project_id &&
                          approvalPersons[forms.project_id]['level2']
                        "
                      >
                        <option
                          v-for="(option, index) in approvalPersons[
                            forms.project_id
                          ]['level2']"
                          :key="index"
                          :value="option.id"
                        >
                          {{ option.name }}
                        </option>
                      </select>
                      <select
                        class="form-control"
                        disabled
                        v-model="forms.approve_person_2"
                        v-else
                      >
                        <option
                          v-for="(option, index) in approvalPersons['level2']"
                          :key="index"
                          :value="option.id"
                        >
                          {{ option.name }}
                        </option>
                      </select>
                      <span class="required">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </CCol>
                </CRow>

                <CRow
                  v-if="
                    (forms.project_id &&
                      approvalPersons[forms.project_id]['level3']) ||
                    (!forms.project_id &&
                      approvalPersons['level3'] &&
                      approvalPersons['level3'].length > 0)
                  "
                >
                  <CCol md="12" class="form-field">
                    <label>
                      {{ $t("commons.label_approve_person3") }}
                      <span class="require">*</span>
                    </label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="overtime.approve3"
                    >
                      <select
                        class="form-control"
                        v-model="forms.approve_person_3"
                        v-if="
                          forms.project_id &&
                          approvalPersons[forms.project_id]['level3']
                        "
                      >
                        <option
                          v-for="(option, index) in approvalPersons[
                            forms.project_id
                          ]['level3']"
                          :key="index"
                          :value="option.id"
                        >
                          {{ option.name }}
                        </option>
                      </select>
                      <select
                        class="form-control"
                        disabled
                        v-model="forms.approve_person_3"
                        v-else
                      >
                        <option
                          v-for="(option, index) in approvalPersons['level3']"
                          :key="index"
                          :value="option.id"
                        >
                          {{ option.name }}
                        </option>
                      </select>
                      <span class="required">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </CCol>
                </CRow>

                <CRow>
                  <CCol md="12" class="form-field">
                    <label>
                      {{ $t("overtime.date") }}
                      <span class="require">*</span>
                    </label>
                    <DatePickerOT
                      :propsDate="forms.date ? forms.date : forms.current_date"
                      v-on:emitDate="workDate"
                      :rules="{ required_date: true }"
                      :name="'overtime.date'"
                    />
                  </CCol>
                </CRow>

                <CRow>
                  <CCol md="12" class="form-field">
                    <label>
                      {{ $t("overtime.start_time") }}
                      <span class="require">*</span>
                    </label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="overtime.start_time"
                    >
                      <b-form-input
                        type="text"
                        v-model="forms.start_time"
                        v-mask="'##:##'"
                        placeholder="HH:mm"
                      />
                      <span class="required">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </CCol>
                </CRow>

                <CRow>
                  <CCol md="12" class="form-field">
                    <label>
                      {{ $t("overtime.end_time") }}
                      <span class="require">*</span>
                    </label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="overtime.end_time"
                    >
                      <b-form-input
                        type="text"
                        v-model="forms.end_time"
                        v-mask="'##:##'"
                        placeholder="HH:mm"
                      />
                      <span class="required">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </CCol>
                </CRow>

                <CRow>
                  <CCol md="12" class="form-field">
                    <label>
                      {{ $t("commons.label_reason") }}
                      <span class="require">*</span>
                    </label>
                    <ValidationProvider
                      rules="required|max:512"
                      v-slot="{ errors }"
                      name="overtime.reason"
                    >
                      <b-form-textarea
                        id="textarea"
                        rows="3"
                        max-rows="6"
                        v-model="forms.reason"
                      >
                      </b-form-textarea>
                      <span class="required">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </CCol>
                </CRow>

                <CRow>
                  <CCol md="12" class="employees-form-ot">
                    <CButton type="submit" class="save-info"
                      >{{ $t("label.save_infomation") }}
                    </CButton>
                    <CButton
                      class="cancel-employee"
                      type="button"
                      @click="cancel()"
                      >{{ $t("commons.cancel") }}
                    </CButton>
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </ValidationObserver>
  </CContainer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import DatePickerOT from "@/components/commons/DatePickerOT";

export default {
  metaInfo() {
    return {
      title: this.$t("page_title.page_overtime_request_create"),
      titleTemplate: "%s | " + this.$t("page_title.head_title"),
    };
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    DatePickerOT,
  },
  computed: {
    ...mapGetters({
      projectsEmployees: "overtime-request/projectsEmployees",
      approvalPersons: "overtime-request/approvalPersons",
    }),
  },
  data() {
    return {
      forms: {
        project_id: "",
        approve_person_1: "",
        approve_person_2: "",
        approve_person_3: "",
        date: null,
        start_time: null,
        end_time: null,
        reason:
          "Link issue: https://backlog.fabbi.io/issue/aBcxYz \nLý do OT: Lý do OT",
        current_date: moment(new Date()).format("DD/MM/YYYY"),
      },
      text: "Link issue: {https://backlog.fabbi.io/issue/aBcxYz}\nLý do OT: {Lý do OT}",
      employees: [],
      approvalPerson: [],
    };
  },

  async created() {
    await this.$store.dispatch("overtime-request/getProjectEmployee");
    if (!this.projectsEmployees) {
      this.$confirmModal(
        this.$t("popup.overtime.message_popup_not_in_project"),
        this.$t("popup.overtime.label_popup_create"),
        this.$t("popup.overtime.label_popup_title_confirm"),
        this.$t("popup.overtime.label_cancel_button"),
        "danger"
      ).then(() => {
        this.$router.push({
          path: "/overtime-requests",
        });
      });
      return;
    }
    await this.$store.dispatch("overtime-request/getApprovalPerson");
    if (this.projectsEmployees) {
      this.forms.project_id = this.projectsEmployees[0]["id"] ?? null;
      this.forms.approve_person_1 =
        this.approvalPersons[this.forms.project_id] &&
        this.approvalPersons[this.forms.project_id]["level1"][0]["id"]
          ? this.approvalPersons[this.forms.project_id]["level1"][0]["id"]
          : "";
      this.forms.approve_person_2 =
        this.approvalPersons[this.forms.project_id] &&
        this.approvalPersons[this.forms.project_id]["level2"]
          ? this.approvalPersons[this.forms.project_id]["level2"][0]["id"]
          : "";
      this.forms.approve_person_3 =
        this.approvalPersons[this.forms.project_id] &&
        this.approvalPersons[this.forms.project_id]["level3"]
          ? this.approvalPersons[this.forms.project_id]["level3"][0]["id"]
          : "";
    } else {
      this.forms.approve_person_1 =
        this.approvalPersons["level1"] && this.approvalPersons["level1"][0]
          ? this.approvalPersons["level1"][0]["id"]
          : "";
      this.forms.approve_person_2 =
        this.approvalPersons["level2"] && this.approvalPersons["level2"][0]
          ? this.approvalPersons["level2"][0]["id"]
          : "";
      this.forms.approve_person_3 =
        this.approvalPersons["level3"] && this.approvalPersons["level3"][0]
          ? this.approvalPersons["level3"][0]["id"]
          : "";
    }
  },

  methods: {
    ...mapActions("layout", ["setLoading"]),
    workDate(data) {
      this.forms.date = data;
    },
    async createOverTimeRequest() {
      this.$root.$loading.start();
      await this.$store
        .dispatch("overtime-request/createOverTime", this.forms)
        .then(() => {
          let message = this.$t("overtime.message_create_success");
          this.$toast(message, null, 2000, "b-toaster-top-center", "success");
          this.$router.push({ path: "/overtime-requests" });
          this.$root.$loading.finish();
        })
        .catch(() => {
          this.$root.$loading.finish();
        });
    },

    cancel() {
      this.$confirmModal(
        this.$t("popup.employee.label_popup_title"),
        this.$t("popup.overtime.label_popup_title"),
        this.$t("popup.employee.label_confirm_button"),
        this.$t("popup.employee.label_cancel_button"),
        "danger"
      ).then((value) => {
        if (value) {
          this.$router.push({ path: "/overtime-requests" });
        }
      });
    },

    changeProject() {
      this.forms.approve_person_1 =
        this.approvalPersons[this.forms.project_id]["level1"][0]["id"];
      this.forms.approve_person_2 = this.approvalPersons[this.forms.project_id][
        "level2"
      ]
        ? this.approvalPersons[this.forms.project_id]["level2"][0]["id"]
        : "";
      this.forms.approve_person_3 = this.approvalPersons[this.forms.project_id][
        "level3"
      ]
        ? this.approvalPersons[this.forms.project_id]["level3"][0]["id"]
        : "";
    },
  },
};
</script>
